module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar disabled = false;\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled;\n}\nvar additionalClasses = [];\nif(disabled)                        additionalClasses.push('disabled');\nif(resourceData.isNew)              additionalClasses.push('isNew');\nif(resourceData.delete)             additionalClasses.push('delete');\nvar fileSymbol = '';\nvar fileTitle = '';\nif(model.extendedButtonActionsGranted){\nfileTitle = '# ' + (resourceData.mediaID || '') + ' - ';\n}\nif(resourceData.missingMainDBEntry){\nadditionalClasses.push('missingMainDBEntry');\nfileSymbol = 'fi fi-exclamation-triangle';\nfileTitle += __('error:fileManagement.missingMainDBEntry.title');\n} else {\nfileSymbol = utils.media.file.getSymbolClass(resourceData.extension);\nfileTitle += (resourceData.url || '');\n}\n%><div class=\"<%- additionalClasses.join(' ') %>\" data-media-id=\"<%- resourceData.mediaID %>\" data-media-index=\"<%- resourceData.index %>\" title=\"<%= fileTitle %>\"><%\n%><div class=\"new\"><%\n%><i class=\"fi fi-file-new\"></i><%\n%></div><%\n%><div class=\"status\"><%\n%><i class=\"delete fi fi-trash\"></i><%\n%></div><%\nvar controls = {\ndelete: true,\ndownload: true,\nassignTags: true,\ncopyToClipboardUrl: true,\n};\nif(resourceData.missingMainDBEntry){\ncontrols = {\ndelete: true\n};\n} else {\nif(config.controls === false){\ncontrols = false;\n}\nelse {\nfor(var command in config.controls){\nif(config.controls[command] === false){\ncontrols[command] = false;\n}\n}\n}\n}\n// NOTE: usually no testing on urls is necessary - but the cms-should be robust and stable even in error cases.\nvar url = resourceData.url || '';\nvar thumb = resourceData.thumb || '';\nif(controls){\n%><div class=\"controls\"><%\nif(controls.copyToClipboardUrl){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboardUrl', context: 'media-file', mode: config.context, symbolOnly: true, icon: 'fi fi-copy-to-clipboard' } }); %><%\n}\nif(controls.assignTags){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'showAssign', context: 'tags', mode: config.context, symbolOnly: true, icon: 'fi fi-mediaFileDetails' } }); %><%\n}\nif(controls.download){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'download', context: 'media-file', mode: config.context, symbolOnly: true } }); %><%\n}\nif(controls.delete){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-file', mode: config.context, symbolOnly: true } }); %><%\n}\n%></div><%\n}\n%><div class=\"symbol <%- fileSymbol %>\" title=\"<%= fileTitle %>\"></div><%\n%><div class=\"file\" title=\"<%= fileTitle %>\"><%= (resourceData.originalName || '') %></div><%\n%></div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\media\\file\\file.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var disabled = false;
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled;
}
var additionalClasses = [];
if(disabled)                        additionalClasses.push('disabled');
if(resourceData.isNew)              additionalClasses.push('isNew');
if(resourceData.delete)             additionalClasses.push('delete');
var fileSymbol = '';
var fileTitle = '';
if(model.extendedButtonActionsGranted){
fileTitle = '# ' + (resourceData.mediaID || '') + ' - ';
}
if(resourceData.missingMainDBEntry){
additionalClasses.push('missingMainDBEntry');
fileSymbol = 'fi fi-exclamation-triangle';
fileTitle += __('error:fileManagement.missingMainDBEntry.title');
} else {
fileSymbol = utils.media.file.getSymbolClass(resourceData.extension);
fileTitle += (resourceData.url || '');
}

    ; __line = 23
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-media-id=\"")
    ; __append( resourceData.mediaID )
    ; __append("\" data-media-index=\"")
    ; __append( resourceData.index )
    ; __append("\" title=\"")
    ; __append(escapeFn( fileTitle ))
    ; __append("\">")
    ; 

    ; __line = 24
    ; __append("<div class=\"new\">")
    ; 

    ; __line = 25
    ; __append("<i class=\"fi fi-file-new\"></i>")
    ; 

    ; __line = 26
    ; __append("</div>")
    ; 

    ; __line = 27
    ; __append("<div class=\"status\">")
    ; 

    ; __line = 28
    ; __append("<i class=\"delete fi fi-trash\"></i>")
    ; 

    ; __line = 29
    ; __append("</div>")
    ; 
var controls = {
delete: true,
download: true,
assignTags: true,
copyToClipboardUrl: true,
};
if(resourceData.missingMainDBEntry){
controls = {
delete: true
};
} else {
if(config.controls === false){
controls = false;
}
else {
for(var command in config.controls){
if(config.controls[command] === false){
controls[command] = false;
}
}
}
}
// NOTE: usually no testing on urls is necessary - but the cms-should be robust and stable even in error cases.
var url = resourceData.url || '';
var thumb = resourceData.thumb || '';
if(controls){

    ; __line = 56
    ; __append("<div class=\"controls\">")
    ; 
if(controls.copyToClipboardUrl){

    ; __line = 58
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboardUrl', context: 'media-file', mode: config.context, symbolOnly: true, icon: 'fi fi-copy-to-clipboard' } }) )
    ; 
}
if(controls.assignTags){

    ; __line = 61
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'showAssign', context: 'tags', mode: config.context, symbolOnly: true, icon: 'fi fi-mediaFileDetails' } }) )
    ; 
}
if(controls.download){

    ; __line = 64
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'download', context: 'media-file', mode: config.context, symbolOnly: true } }) )
    ; 
}
if(controls.delete){

    ; __line = 67
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-file', mode: config.context, symbolOnly: true } }) )
    ; 
}

    ; __line = 69
    ; __append("</div>")
    ; 
}

    ; __line = 71
    ; __append("<div class=\"symbol ")
    ; __append( fileSymbol )
    ; __append("\" title=\"")
    ; __append(escapeFn( fileTitle ))
    ; __append("\"></div>")
    ; 

    ; __line = 72
    ; __append("<div class=\"file\" title=\"")
    ; __append(escapeFn( fileTitle ))
    ; __append("\">")
    ; __append(escapeFn( (resourceData.originalName || '') ))
    ; __append("</div>")
    ; 

    ; __line = 73
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\media\file\file.ejs

}